import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { Textarea } from '@1trading/react/components/ui/textarea';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BINARY_ANSWERS } from '@/constants/answers';
import type { InstitutionRegulatoryInformationOrDefaults } from '@/features/institution/regulatory-information/schema';

const InstitutionRegulatoryInformationFieldsetOffshoreLicence = () => {
  const form = useFormContext<InstitutionRegulatoryInformationOrDefaults>();
  const { t } = useTranslation();
  const offshoreLicence = form.watch('offshoreLicence');

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="offshoreLicence"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.regulatoryInformation.offshoreLicence.offshoreLicence')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.regulatoryInformation.offshoreLicence.offshoreLicence')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      {offshoreLicence === 'YES' ? (
        <FormField
          control={form.control}
          name="offshoreLicenceBranches"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('institutionDetails.regulatoryInformation.offshoreLicence.offshoreLicenceBranches')}*</FormLabel>
              <FormControl>
                <Textarea {...field} placeholder={t('institutionDetails.regulatoryInformation.placeholders.offshoreLicenceBranches')} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      ) : null}
    </div>
  );
};
InstitutionRegulatoryInformationFieldsetOffshoreLicence.displayName = 'InstitutionRegulatoryInformationFieldsetOffshoreLicence';

export { InstitutionRegulatoryInformationFieldsetOffshoreLicence };
